/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { likeControllerCreate } from '../fn/like/like-controller-create';
import { LikeControllerCreate$Params } from '../fn/like/like-controller-create';
import { likeControllerDelete } from '../fn/like/like-controller-delete';
import { LikeControllerDelete$Params } from '../fn/like/like-controller-delete';
import { likeControllerFindByUserAndGallery } from '../fn/like/like-controller-find-by-user-and-gallery';
import { LikeControllerFindByUserAndGallery$Params } from '../fn/like/like-controller-find-by-user-and-gallery';
import { likeControllerFindLikesByGallery } from '../fn/like/like-controller-find-likes-by-gallery';
import { LikeControllerFindLikesByGallery$Params } from '../fn/like/like-controller-find-likes-by-gallery';
import { LikeDto } from '../models/like-dto';

@Injectable({ providedIn: 'root' })
export class LikeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `likeControllerCreate()` */
  static readonly LikeControllerCreatePath = '/api/v1/like';

  /**
   * 좋아요 생성.
   *
   * 좋아요를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `likeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  likeControllerCreate$Response(params: LikeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<LikeDto>> {
    return likeControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 좋아요 생성.
   *
   * 좋아요를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `likeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  likeControllerCreate(params: LikeControllerCreate$Params, context?: HttpContext): Observable<LikeDto> {
    return this.likeControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<LikeDto>): LikeDto => r.body)
    );
  }

  /** Path part for operation `likeControllerDelete()` */
  static readonly LikeControllerDeletePath = '/api/v1/like/remove/{galleryId}';

  /**
   * 좋아요 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `likeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerDelete$Response(params: LikeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return likeControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 좋아요 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `likeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerDelete(params: LikeControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.likeControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `likeControllerFindByUserAndGallery()` */
  static readonly LikeControllerFindByUserAndGalleryPath = '/api/v1/like/check/{galleryId}';

  /**
   * 사용자와 좋아요 상태 확인.
   *
   * 특정 사용자와 좋아요 상태를 확인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `likeControllerFindByUserAndGallery()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindByUserAndGallery$Response(params: LikeControllerFindByUserAndGallery$Params, context?: HttpContext): Observable<StrictHttpResponse<LikeDto>> {
    return likeControllerFindByUserAndGallery(this.http, this.rootUrl, params, context);
  }

  /**
   * 사용자와 좋아요 상태 확인.
   *
   * 특정 사용자와 좋아요 상태를 확인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `likeControllerFindByUserAndGallery$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindByUserAndGallery(params: LikeControllerFindByUserAndGallery$Params, context?: HttpContext): Observable<LikeDto> {
    return this.likeControllerFindByUserAndGallery$Response(params, context).pipe(
      map((r: StrictHttpResponse<LikeDto>): LikeDto => r.body)
    );
  }

  /** Path part for operation `likeControllerFindLikesByGallery()` */
  static readonly LikeControllerFindLikesByGalleryPath = '/api/v1/like/gallery/{galleryId}';

  /**
   * 갤러리의 모든 좋아요 조회.
   *
   * 해당 갤러리의 좋아요를 모두 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `likeControllerFindLikesByGallery()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindLikesByGallery$Response(params: LikeControllerFindLikesByGallery$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LikeDto>>> {
    return likeControllerFindLikesByGallery(this.http, this.rootUrl, params, context);
  }

  /**
   * 갤러리의 모든 좋아요 조회.
   *
   * 해당 갤러리의 좋아요를 모두 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `likeControllerFindLikesByGallery$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindLikesByGallery(params: LikeControllerFindLikesByGallery$Params, context?: HttpContext): Observable<Array<LikeDto>> {
    return this.likeControllerFindLikesByGallery$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LikeDto>>): Array<LikeDto> => r.body)
    );
  }

}
